import { render } from "./About.vue?vue&type=template&id=c55e164c&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=c55e164c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\McCoy\\Desktop\\Coding\\Work\\caby_landing_page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c55e164c"]])

export default __exports__